export default {
  askQuestion: () => ['post', '/api/help/ask-question'],
  confirmUsername: () => ['post', '/api/help/confirm-username'],
};
